<template>
  <div class="container-fluid">
    <h4 class="m-3">Детальная карточка коллекции</h4>
    <el-form ref="form" label-width="250px" label-position="left" id="uploadForm" name="uploadForm">
      <el-form-item label="Название">
        <el-input v-model="collection.title" disabled></el-input>
      </el-form-item>
      <el-form-item label="Описание">
        <el-input type="textarea" :rows="3" v-model="collection.description" disabled></el-input>
      </el-form-item>
      <el-form-item label="Цена «От»">
        <el-input v-model="collection.fromPrice" disabled></el-input>
      </el-form-item>
      <el-form-item label="Активность">
        <el-checkbox v-model="collection.activity"></el-checkbox>
      </el-form-item>
      <el-form-item label="Сортировка">
        <el-input v-model="collection.sort"></el-input>
      </el-form-item>
      <el-form-item label="Изображения">
        <el-upload action="" list-type="picture" :file-list="fileList" :limit="1" :auto-upload="false" disabled>
        </el-upload>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="update">Изменить</el-button>
        <el-button @click="back">Отмена</el-button>
      </el-form-item>
    </el-form>
    <hr>
    <h4>Товары в коллекции</h4>
    <el-table
        :data="products"
        v-loading="loading"
        size="small"
        empty-text="Не товаров"
    >
      <el-table-column
          prop="id"
          label="Id"
          width="100">
      </el-table-column>
      <el-table-column
          prop="article"
          label="Артикул"
          width="180">
      </el-table-column>
      <el-table-column
          prop="title"
          label="Название"
          width="380">
      </el-table-column>
      <el-table-column
          prop="section"
          label="Разделы каталога"
          width="460">
          <template slot-scope="scope">
              <p>{{ products[scope.$index].section.path }}</p>
          </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from "axios";
import getFileList from '../../composable/utils/getFileList';
import getErrors, { getTextErrors } from '../../composable/utils/getErrors';
import useFormData from '../../composable/useFormData'

export default {
  name: "CollectionUpdate",  
  data: function() {
    return {
      collection: {
        id: 0,
        slug: '',
        title: '',
        img: [],
        description: '',
        activity: false,
        sort: 0,
        fromPrice: 0,
      },
      products: [],
      fileList: [],
      errors: [],
    }
  },
  mounted() {
    this.fetch();
    this.fetchProducts();
  },

  methods: {
    back() {
      this.$router.go(-1)
    },
    fetch: function () {
      axios.get('catalog/collection/' + this.$route.params.id).then((response) => {
        this.initProduct(response.data)
        this.setFileList(response?.data.img)
      }
      ).catch((errors) => {
        if (errors.response.status === 401) {
          this.$router.push('/login');
        }
        if (errors.response.status === 422) {
          this.setErrors(errors.response.data.errors)
        }
      });
    },

    fetchProducts: function() {
      axios.get(`catalog/collection/${this.$route.params.id}/product`)
      .then((r) => {
        this.products = r.data
      })
    },

    update() {
      const { execute } = useFormData()

      const data = execute().setFields([
        'activity',
        'sort',
      ]).getFormData(this.collection)

      axios.post('catalog/collection/' + this.collection.id, data).then((response) => {
        if (response.status === 200) {
          this.back()
        }
      }).catch((errors) => {
        if (errors.response.status === 401) {
          this.$router.push('/login');
        }
        if (errors.response.status === 422) {
          this.setErrors(errors.response.data.errors)
          this.$notify.error(getTextErrors(this.errors))
        }
      });
    },

    setFileList(value) {
      this.fileList = getFileList(value)
    },

    setErrors(err) {
      this.errors = getErrors(err)
    },

    initProduct(value) {
      
      if (value) {
        this.collection.id = value.id || 0;
        this.collection.slug = value.slug || '';
        this.collection.title = value.title || '';
        this.collection.img = value.img || [];
        this.collection.description = value.description || '';
        this.collection.activity = value.activity || false;
        this.collection.sort = value.sort || 0;
        this.collection.fromPrice = value.from_price || 0;
      }
    }
  }
}
</script>

<style scoped>

</style>